import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PublicCreativeUnitPackageCategory } from '../../../../../../../api/src/creative-unit-package-category/creative-unit-package-category.entity';
import { CreativeUnitPackageCategoryService } from '../creative-unit-package-category.service';

@Component({
  selector: 'app-creative-unit-package-category-picker',
  templateUrl: './creative-unit-package-category-picker.component.html',
  styleUrls: ['./creative-unit-package-category-picker.component.scss']
})
export class CreativeUnitPackageCategoryPickerComponent implements OnInit {
	@Input() categories: PublicCreativeUnitPackageCategory[] = [];
	@Input() selected: PublicCreativeUnitPackageCategory[] = [];
	@Output() selectedChange: EventEmitter<PublicCreativeUnitPackageCategory[]> = new EventEmitter<PublicCreativeUnitPackageCategory[]>();

	constructor(
		public creativeUnitPackageCategoryService: CreativeUnitPackageCategoryService
	) { }

	ngOnInit(): void {
		if (!this.categories.length) {
			this.loadCategories();
		}
	}

	loadCategories(): void {
		this.creativeUnitPackageCategoryService.get({ page: 1, limit: 1000, filters: {}, sort: { sortBy: 'created' } })
			.subscribe((response) => {
				console.log(response);
				this.categories = response.data;
			});
	}

	getCategory(id: string): PublicCreativeUnitPackageCategory {
		return this.selected?.find((category) => category.id === id);
	}

	setCategoryValues(categoryId: string, values: PublicCreativeUnitPackageCategory['values']) {
		console.log('setCategoryValues', categoryId, values);

		let newSelected = this.selected ? [...this.selected] : [];

		// Upsert the category with new values into the selected array.
		if (newSelected.some((category) => category.id === categoryId)) {
			newSelected = newSelected.map((category) => {
				if (category.id === categoryId) {
					return { ...category, values };
				}

				return category;
			});
		} else {
			let category = this.categories.find((category) => category.id === categoryId);
			if (category) {
				newSelected.push({ ...category, values });
			}
		}

		// Strip any categories that have no values.
		newSelected = newSelected.filter((category) => category.values && Object.keys(category.values).length);

		this.selectedChange.emit(newSelected);
	}

}
